import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onSuccessHandler, onErrorHandler } from './handlers';
import { setevaluateOrder,setpdpLinkForOrders, setreorderFailMsg, startLoading, stopLoading } from './application';
import i18n from '../utils/translations/i18n';
import { ReOrder } from '../enums/reOrder';
import { Page } from '../enums/page';
import { generatePdpLinkForLineItem } from '../components/shared/sections/my-account/utils';
import { DispatchErrorsEvent } from '../components/order-confirmation/ga-utils';

declare const window: any;

export const reorderApi = createApi({
    reducerPath: 'reorderApi',
    baseQuery: fetchBaseQuery({
        baseUrl:  window.Config?.REORDER_API ?? "https://npr-reorder.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set('x-api-key', window.Config.NP_API_KEY_CLIENT_JS);
            headers.set("content-type" , "application/json");
            return headers
        },
    }),
    tagTypes: ['reorder'],
    endpoints: (builder) => ({
      evaluateReorder: builder.mutation({
        query: ({ ...data }) => ({
          url: `v1/evaluateReorder`,
          method: 'POST',
          body: {
            ...data,
        }
        }),
        async onQueryStarted(args, { dispatch,getState, queryFulfilled }) {
            try{
                const {data} = await queryFulfilled;
                dispatch(onSuccessHandler(ReOrder.EVALUATEREORDER, {dataReOrder:data}));
            }
            catch(error){
                console.log(error);
                const {applicationState: { evaluateOrder }}: any = getState();
                const result = args?.Orders?.flatMap(order => order?.lineItems?.map(lineItem => ({ error: 'error', lineItemId: lineItem?.id })));
                const reorderstate:any = evaluateOrder?.dataReOrder?.length > 0 ? [...result, ...evaluateOrder?.dataReOrder] : result;
                dispatch(setevaluateOrder({ dataReOrder: reorderstate }));
                dispatch(onErrorHandler({operation: 'EvaluateReorder', err: JSON.stringify(error), errMsg: 'Error: while evaluate reorder', api: 'v1/evaluateReorder'}));
            }
        }
      }),
      reorder: builder.mutation({
        query: ({ webCode:webCode,isHomePageReorder, ...data }) => ({
          url: `v1/reorder`,
          method: 'POST',
          body: {
            ...data,
        }
        }),
        async onQueryStarted(args, { dispatch,getState, queryFulfilled }) {
            try{
                dispatch(startLoading());
                const {data} = await queryFulfilled;
                dispatch(onSuccessHandler(ReOrder.REORDER, {resp:data, args:args}));
            }
            catch(error){
                console.log(error);
                dispatch(setreorderFailMsg({errorMsg: i18n.t('sign_up.somethingWrong'), lineItemId: args.lineItem?.[0].lineItemId}))
                dispatch(onErrorHandler({operation: 'Reorder', err: JSON.stringify(error), errMsg: 'Error: while reorder', api: 'v1/reorder'}));
            }
            finally{
                const {applicationState: { currentPage }}: any = getState();
                currentPage !== Page.SHOPPINGBAG && dispatch(stopLoading());
            }
        }
      }),
      generatePDPLink: builder.mutation({
        query: ({ ...data }) => ({
          url: `v1/getProductDetail`,
          method: 'POST',
          body: {
            ...data,
        }
        }),
        async onQueryStarted(args, { dispatch,getState, queryFulfilled }) {
            try{
                const {data} = await queryFulfilled;
                dispatch(onSuccessHandler(ReOrder.GENERATEPDPLINK, {resp:data, args:args}));
            }
            catch(error){
                console.log(error);
                const {applicationState: { pdpLinkForOrders }}: any = getState();
               
                let dataPdp:any ={};
                args.Orders.map((individualOrder:any)=>{
                    let curentOrderId =individualOrder.id;
                    dataPdp[curentOrderId] = {};
                    individualOrder.lineItems.map((lineItem:any)=>{
                        dataPdp[curentOrderId][lineItem.id] = generatePdpLinkForLineItem(lineItem,lineItem.selectionAttributes);
                    })
                });
                dispatch(setpdpLinkForOrders({...dataPdp,...pdpLinkForOrders}));
                dispatch(onErrorHandler({operation: 'generatePDPLink', err: JSON.stringify(error), errMsg: 'Error: while generatePDPLink', api: 'v1/getProductDetail'}));
            }
        }
      }),
      fetchreorderables: builder.mutation({
        query: (data) => ({
            url : 'v1/fetchreorderables',
            method: 'POST',
            body: data
        }),
        async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
            try{
                const {data} = await queryFulfilled;
                dispatch(stopLoading());
                return data;
            }
            catch(error){
                console.error(error);
                DispatchErrorsEvent('Could not load Reorder section');
                dispatch(stopLoading());
                dispatch(onErrorHandler({operation: 'fetchreorderables', err: JSON.stringify(error), errMsg: 'Error: while fetchreorderables', api: 'v1/fetchreorderables'}));
            } 
        },
      }),
    }),
})

export const { useEvaluateReorderMutation, useReorderMutation, useGeneratePDPLinkMutation, useFetchreorderablesMutation } = reorderApi;

